/* eslint-disable arrow-body-style */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import { Progress, Spin } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DokanCard from "./card/DokanCard";
import {fetchProfileData} from '../redux/overview/profile/profileActions';

const DokanProfileCompleteStatus = ({ handleIsHidden }) => {
   const {profileData, vendor, loading} = useSelector((state) => state.profile)

   const dispatch= useDispatch()

   useEffect(() => {
     dispatch(fetchProfileData())
   },[dispatch, profileData])

   const completeProfile = () => {console.log('go to link');}

  return (
  <Spin spinning={loading}>
  <div id="profile-completeness" className="flex-grow-1">
    <DokanCard
      hasTitle={false}
      disableMargin
      hasCustomBg
      customBgColor="bg-blue-dodger"
    >

      {/** new one profile with responsive */}
      <div className="grid md:grid-flow-row md:row-gap-3 lg:grid-flow-col min-w-full">
        <div className="flex">
        <div className="h-12 w-12 rounded-full shadow-sm bg-white">
            <img
              className="h-full w-full object-cover p-1 rounded-full"
              src={`${profileData.image}`}
              alt="Your avatar"
            />
          </div>
          <div>
          <div className="ml-2 text-white">
            <div className="text-dokan-sm-title">Welcome back,</div>
            <div className="text-dokan-lg-title font-extrabold">{`${vendor.store_name ?? ''} !`}</div>
            <div className="w-auto md:w-64">
              <Progress
                percent={50}
                status="active"
                size="small"
                showInfo={false}
                strokeColor="#00C854"
                
              />
              <div className="font-hairline">Your profile is <span className="font-extrabold">{vendor.profile_completion?.progress || 0}% Completed</span> </div>
            </div>
          </div>
          </div>
          
        </div>
        <div>
        <div className="flex-1 m-2 md:m-0 h-full p-4 rounded-md bg-white">
          <div className="grid grid-rows-1 justify-items-center md:grid-cols-2 my-1">
            <div className="justify-items-center md:justify-self-start pl-2">
                <div className="text-dokan-lg-title text-center md:text-left font-extrabold">
                {vendor.profile_completion?.progress || 0}<span>%</span>
                </div>
                <div className="py-2 text-secondary">
                  Profile completion
                </div>
            </div>
            <div className="justify-items-center md:justify-self-end">
              <button type="button" className="bg-green-500 text-white rounded-md px-3 py-3 mx-3 my-3" onClick={completeProfile}>
                Complete Your Profile
              </button>
            </div>
          </div>
        </div>
        </div>
      </div>
    </DokanCard>
  </div>
  </Spin>
  )};

export default DokanProfileCompleteStatus;
